/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const fullSlideElement = document.querySelector('.home-full-slide');

    if (fullSlideElement) {
      const slideCount = fullSlideElement.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
      
      const fullSlide = new Swiper('.home-full-slide', {
        loop: slideCount > 1,
        autoplay: slideCount > 1 ? {
          delay: 5000,
        } : false,
        speed: 1000,
        pagination: {
          el: '.home-full-pagination',
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: ".home-slide-next",
          prevEl: ".home-slide-prev",
        },
      });

      if (slideCount <= 1) {
        const nextButton = document.querySelector('.home-slide-next');
        const prevButton = document.querySelector('.home-slide-prev');
        
        if (nextButton) nextButton.style.display = 'none';
        if (prevButton) prevButton.style.display = 'none';
      }
    }
  };

  const homeCollectionSlider = () => {
    const homeCollectionSlider = new Swiper('.home-collection-slider ', {
      slidesPerView: 3,
      spaceBetween: 40,
      pagination: {
        el: '.home-collection-pagination',
        type: "progressbar",
      },
      navigation: {
        nextEl: ".home-collection-next",
        prevEl: ".home-collection-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
  }

  const homeFeaturedSlider = () => {
    const homeFeaturedSlider = new Swiper('.home-featured-slider ', {
      slidesPerView: 4,
      spaceBetween: 0,
      pagination: {
        el: '.home-featured-pagination',
        type: "progressbar",
      },
      navigation: {
        nextEl: ".home-featured-next",
        prevEl: ".home-featured-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
    });
  }

  const homeBlogSlider = () => {
    const homeBlogSlider = new Swiper('.home-blog-slider', {
      slidesPerView: 3,
      spaceBetween: 0,
      navigation: {
        nextEl: ".home-blog-next",
        prevEl: ".home-blog-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 2,
        },
        1540: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
    });
  }

  const homeStorySlider = () => {
    const homeStorySlider = new Swiper('.home-story-slider', {
      slidesPerView: 1,
      spaceBetween: 0, 
      effect: "fade",
      autoHeight:true,
      pagination: {
        el: ".home-story-nav",
        type: "fraction",
      },
      navigation: {
        nextEl: ".home-story-next",
        prevEl: ".home-story-prev",
      },
    });
  }

  const homeInstagramSlider = () => {
    // const homeInstagramSlider = new Swiper('.home-insta-post-slider', {
    //   loop: true,
    //   autoplay: {
    //     delay: 1,
    //     disableOnInteraction: false
    //   },
    //   slidesPerView: 'auto',
    //   speed: 3000,
    //   spaceBetween: 20, 
    //   grabCursor: true,
    //   mousewheelControl: true,
    //   keyboardControl: true,
    // });
  }

  const aboutStorySlider = () => {
    const aboutStorySlider = new Swiper('.about-story-slider', {
      slidesPerView: 4,
      spaceBetween: 15,
      pagination: {
        el: '.about-story-pagination',
        type: "progressbar",
      },
      navigation: {
        nextEl: ".about-story-next",
        prevEl: ".about-story-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1340: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
    });
  }

  const productMobileSlide = () => {
    if ($(window).innerWidth() < 767) {
      // alert("asd");
      const productMobileSlide = new Swiper('.page-product-detail .product-img', {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          // nextEl: ".about-story-next",
          // prevEl: ".about-story-prev",
        },
      });
    }
  }

  const loginInstaSlide = () => {
    const loginInstaSlide = new Swiper('.login-insta-slider', {
      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
      slidesPerView: 'auto',
      speed: 3000,
      spaceBetween: 15, 
      grabCursor: true,
      mousewheelControl: true,
      keyboardControl: true,
    });
  }

  const init = () => {
    fullSlider();
    homeCollectionSlider();
    homeFeaturedSlider();
    homeBlogSlider();
    homeStorySlider();
    homeInstagramSlider();
    aboutStorySlider();
    productMobileSlide();
    loginInstaSlide();
  };

  return {
    init,
  };
})();

export default slider;
